import { useState } from "react";
import { ShieldCheck, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const GRADE = { A: "text-emerald-400 border-emerald-500/40 bg-emerald-500/10", B: "text-sky-300 border-sky-500/40 bg-sky-500/10", C: "text-amber-300 border-amber-500/40 bg-amber-500/10", D: "text-red-300 border-red-500/40 bg-red-500/10" };

// TechValidator badge: QA grade + issues tooltip; runs validation on demand for older tracks.
export default function QaBadge({ gen, onUpdated }) {
  const [busy, setBusy] = useState(false);
  const [open, setOpen] = useState(false);
  const qa = gen.metadata?.qa;
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/generations/${gen.id}/validate`); onUpdated?.({ ...gen, metadata: { ...gen.metadata, qa: data.qa } }); toast.success(`QA grade ${data.qa.grade} (${data.qa.score}/100)`); }
    catch (e) { toast.error(e.response?.data?.detail || "Validation failed"); }
    finally { setBusy(false); }
  };
  if (!qa?.grade) {
    return <button type="button" onClick={run} disabled={busy} className="text-[10px] font-mono px-2 py-0.5 rounded-full border border-border text-muted-foreground hover:text-foreground inline-flex items-center gap-1" data-testid={`qa-run-${gen.seq}`}>{busy ? <Loader2 size={10} className="animate-spin" /> : <ShieldCheck size={10} />} QA</button>;
  }
  return (
    <span className="relative inline-block">
      <button type="button" onClick={() => setOpen((o) => !o)} className={`text-[10px] font-mono px-2 py-0.5 rounded-full border inline-flex items-center gap-1 ${GRADE[qa.grade] || ""}`} title={qa.issues.length ? qa.issues.join(" · ") : "No technical issue detected"} data-testid={`qa-badge-${gen.seq}`}><ShieldCheck size={10} /> QA {qa.grade} · {qa.score}</button>
      {open && (
        <div className="absolute z-20 mt-1 left-0 w-72 rounded-xl border border-border bg-card p-3 text-[11px] space-y-1 shadow-xl" data-testid={`qa-details-${gen.seq}`}>
          <p className="font-semibold">TechValidator · {qa.grade} ({qa.score}/100)</p>
          <p className="font-mono text-muted-foreground">peak {qa.peak_dbfs} dBFS · RMS {qa.rms_dbfs} dBFS · {qa.sample_rate} Hz · {qa.channels}ch · {qa.duration_sec}s{qa.loop_checked ? ` · seam Δ${qa.loop_seam_db} dB` : ""}</p>
          {qa.issues.length ? <ul className="list-disc pl-4 text-amber-200">{qa.issues.map((i) => <li key={i}>{i}</li>)}</ul> : <p className="text-emerald-400">No technical issue detected.</p>}
          <button type="button" onClick={run} disabled={busy} className="text-primary hover:underline" data-testid={`qa-rerun-${gen.seq}`}>{busy ? "Re-checking…" : "Re-check"}</button>
        </div>
      )}
    </span>
  );
}
